module.exports = __webpack_public_path__ + "static/media/circlePlus.dc07706c.svg";